import { useEffect } from "react"
import { MediaState } from "@/types/types"
import { getEmptyArtwork } from "@/utils/utils"
import useMediaState from "@/common/hooks/useMediaState"
import useAudioLoaded from "@/common/hooks/useAudioLoaded";
import { useAudioPlayback } from "@/common/hooks/useAudioPlayback.ts";
import useCurrentTrack from "@/common/hooks/useCurrentTrack.ts";
import useCurrentExplorerItem from "@/common/hooks/useCurrentExplorerItem.ts";
import usePlaymodeSearchParam from "@/common/hooks/usePlaymodeSearchParam.ts";

const baseURL = process.env.NEXT_PUBLIC_APP_API_BASE_URL
export const usePlayerMediaSession = () => {
  const currentExplorerItem = useCurrentExplorerItem()

  const currentTrack = useCurrentTrack()
  const [mediaState] = useMediaState()
  const [audioLoaded] = useAudioLoaded()
  const isPlaying = mediaState === MediaState.PLAYING
  const [playmode] = usePlaymodeSearchParam()
  const {
    seek,
    play,
    pause,
    playPreviousTrack,
    playNextTrack,
  } = useAudioPlayback()

  useEffect(() => {
    if ("mediaSession" in navigator && isPlaying) {
      navigator.mediaSession.playbackState = "playing"
    }

    if ("mediaSession" in navigator && !isPlaying) {
      navigator.mediaSession.playbackState = "paused"
    }
  }, [
    isPlaying,
    currentTrack
  ])

  useEffect(() => {
    if ("mediaSession" in navigator && currentTrack && audioLoaded) {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: currentTrack?.name,
        artist: currentTrack?.artist ?? currentTrack?.trackInfo?.artist ?? "",
        album: currentTrack?.trackInfo?.album ?? "album?",
        artwork: currentTrack?.coverArt
          ? [
            {
              //src: URL.createObjectURL(convertBase64ToBlob(currentTrack?.coverArt)),
              src: baseURL + `/track/${currentTrack?.explorerItemId}/cover-art`,
              sizes: "256x256,384x384,512x512",
              type: currentTrack?.coverArtMimeType,
            },
          ]
          : [{ src: getEmptyArtwork(70, 70)?.toDataURL() || '' }],
      })

      navigator.mediaSession.setActionHandler("previoustrack", function () {
        playPreviousTrack(currentExplorerItem!);
      })

      navigator.mediaSession.setActionHandler("nexttrack", function () {
        playNextTrack(currentExplorerItem!);
      })

      navigator.mediaSession.setActionHandler("play", function () {
        play(currentExplorerItem)
      })

      navigator.mediaSession.setActionHandler("pause", function () {
        pause()
      })

      navigator.mediaSession.setActionHandler("seekto", (evt) => {
        seek(Number(evt.seekTime));
      });
    }
  }, [
    isPlaying,
    currentTrack,
    audioLoaded,
    playmode,
    playPreviousTrack,
    playNextTrack,
    play,
    pause,
    currentExplorerItem,
    seek
  ])
}
